import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-attachment-mng.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-attachment-mng.component.scss?ngResource";
import { Component, EventEmitter, forwardRef, Input, Output, } from "@angular/core";
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators, } from "@angular/forms";
import { AppControllerService } from "../../../../app-controller.service";
import { AttachmentManagerService } from "../shared/services/attachment-manager.service";
import { AttachmentManagerConstants } from "../shared/constants/attachment-manager.constant";
import { SharedConstants } from "../../../constants/shared.constants";
import { UserInformationService } from "../../../services/user/user-information.service";
import { AppConfig } from "../../../../app.config";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let AddAttachmentMngComponent = class AddAttachmentMngComponent {
    formBuilder;
    appController;
    attachmentMngService;
    userInformationService;
    attachmentTypeCtrl = AttachmentManagerConstants.ATTACHMENT_TYPE_CTRL;
    attachmentTypeLbl = AttachmentManagerConstants.ATTACHMENT_TYPE_LBL;
    componentTypeControl = AttachmentManagerConstants.COMPONENT_TYPE_CTRL;
    descriptionCtrl = AttachmentManagerConstants.DESCRIPTION_CTRL;
    descriptionLbl = AttachmentManagerConstants.DESCRIPTION_LBL;
    uploadedByNameCtrl = AttachmentManagerConstants.UPLOADED_BY_NAME;
    uploadedByIdCtrl = AttachmentManagerConstants.UPLOADED_BY_NAME;
    moduleIdCtrl = AttachmentManagerConstants.MODULE_ID;
    appIdCtrl = AttachmentManagerConstants.APP_ID;
    fileNameCtrl = AttachmentManagerConstants.FILE_NAME_CTRL;
    fileSizeCtrl = AttachmentManagerConstants.FILESIZE_CTRL;
    fileLbl = AttachmentManagerConstants.FILE_LBL;
    fileCtrl = AttachmentManagerConstants.FILES_CTRL;
    maxLengthError = AttachmentManagerConstants.MAX_LENGTH;
    notEmptyError = SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    notFileError = SharedConstants.FILE_CONTROL_DEFAULT;
    attachmentFormGroup;
    getAttachmentType;
    attachmentTypeContents = new Array();
    submit;
    allowedFiles;
    maxFileSize;
    user;
    authenticatedUserSubscription;
    getAttachmentTypeLookupSubscription;
    attachmentFormSubscription;
    get value() {
        return this.attachmentFormGroup.value;
    }
    set value(value) {
        this.attachmentFormGroup.setValue(value);
        this.onChange(value);
        this.onTouched();
    }
    componentType;
    jobId;
    attachmentType;
    submitChanges = new EventEmitter();
    constructor(formBuilder, appController, attachmentMngService, userInformationService) {
        this.formBuilder = formBuilder;
        this.appController = appController;
        this.attachmentMngService = attachmentMngService;
        this.userInformationService = userInformationService;
        this.initForm();
    }
    ngAfterViewInit() {
        this.attachmentFormGroup
            .get(this.moduleIdCtrl)
            .setValue(this.appController.selectedModuleID);
        this.attachmentFormGroup
            .get(this.componentTypeControl)
            .setValue(this.componentType);
        this.attachmentFormGroup
            .get(this.uploadedByNameCtrl)
            .setValue(`${this.user.firstName}  ${this.user.lastName}`);
        this.attachmentFormGroup.get(this.uploadedByIdCtrl).setValue(this.user.id);
    }
    ngOnInit() {
        this.maxFileSize = AppConfig.settings.uploadFile.maximumSize;
        this.allowedFiles = AppConfig.settings.uploadFile.agsSupportedAttachmentFileTypes.split(",");
        this.authenticatedUserSubscription =
            this.userInformationService.$authenticatedUser
                .subscribe((user) => {
                this.user = user;
            });
        this.getAttachmentTypeLookupSubscription =
            this.attachmentMngService.getAttachmentTypeLookup(+this.appController.selectedModuleID)
                .subscribe((response) => {
                this.getAttachmentType = response;
                this.attachmentTypeContents = this.getAttachmentType.map((data) => JSON.parse(data.content)).sort((a, b) => 0 - (a.type.toLowerCase() > b.type.toLowerCase() ? -1 : 1));
            });
        this.attachmentFormSubscription = this.attachmentFormGroup.valueChanges.subscribe((value) => {
            this.onChange(value);
            this.onTouched();
            this.submitChanges.emit(false);
        });
    }
    initForm() {
        if (!this.componentType || this.componentType.length === 0) {
            this.componentType =
                AttachmentManagerConstants.COMPONENT_TYPE_DEFAULT_NAME;
        }
        this.attachmentFormGroup = this.formBuilder.group({
            id: [],
            attachmentType: [null, Validators.required],
            description: [
                "",
                [
                    Validators.required,
                    Validators.maxLength(AttachmentManagerConstants.MAXIMUM_CHARACTERS),
                ],
            ],
            uploadedByName: [],
            componentType: [],
            moduleId: [],
            fileName: [],
            uploadedById: [],
            fileSize: [],
            replacedBy: [],
            revision: [],
            file: [null, Validators.required],
        });
    }
    uploadFile(file) {
        this.attachmentFormGroup.get(this.fileCtrl).setValue(file);
        const fileExtension = file.name.split(".").pop();
        const fileName = file.name.replace("." + fileExtension, "");
        this.attachmentFormGroup.get(this.fileNameCtrl).setValue(fileName);
        this.attachmentFormGroup.get(this.fileSizeCtrl).setValue(file.size);
    }
    handleAttachmentType() {
        if (this.attachmentType &&
            this.attachmentType !== undefined &&
            this.attachmentType != null) {
            this.attachmentFormGroup
                .get(this.attachmentTypeCtrl)
                .setValue(this.attachmentType);
        }
        else if (!this.attachmentFormGroup.get(this.attachmentTypeCtrl).value ||
            this.attachmentFormGroup.get(this.attachmentTypeCtrl).value == null) {
            this.attachmentFormGroup
                .get(this.attachmentTypeCtrl)
                .setErrors({ required: true });
        }
    }
    onDeleteFile(index) {
        this.attachmentFormGroup.get(this.fileCtrl).setValue(null);
        this.attachmentFormGroup.get(this.fileCtrl).setErrors({ required: true });
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        if (value) {
            this.value = value;
        }
        if (value === null) {
            this.attachmentFormGroup.reset();
        }
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // communicate the inner form validation-tab to the parent form
    validate(_) {
        return this.attachmentFormGroup.valid
            ? null
            : { profile: { valid: false } };
    }
    ngOnChanges(change) {
        this.submit = change.submit.currentValue;
        if (change.attachmentType) {
            // tslint:disable-next-line: no-unused-expression
            this.attachmentType === change.attachmentType.currentValue;
        }
        if (this.attachmentType) {
            this.handleAttachmentType();
        }
        if (this.submit) {
            this.handleAttachmentType();
        }
    }
    static ctorParameters = () => [
        { type: FormBuilder },
        { type: AppControllerService },
        { type: AttachmentManagerService },
        { type: UserInformationService }
    ];
    static propDecorators = {
        submit: [{ type: Input }],
        componentType: [{ type: Input }],
        jobId: [{ type: Input }],
        attachmentType: [{ type: Input }],
        submitChanges: [{ type: Output }]
    };
};
AddAttachmentMngComponent = __decorate([
    Component({
        selector: "app-add-attachment-mng",
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AddAttachmentMngComponent),
                multi: true,
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => AddAttachmentMngComponent),
                multi: true,
            },
        ],
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AddAttachmentMngComponent);
export { AddAttachmentMngComponent };
